var exports = {
  "I0": "fadeInAnimation__iQlUj-",
  "Ln": "omnibar__dmJza6",
  "zZ": "isFixed__ZD0dVf",
  "ar": "isFocused__kNkkWK",
  "LG": "addButtonContainer__-Q1_ve",
  "bK": "addItemButton__FNmi9L",
  "Kf": "inputContainer__kpojzl",
  "bg": "omnibarInput__g9sqaY",
  "s6": "repositorySuggestions__fQgNVn",
};

module.exports = exports;
